export const DEFAULT_MARKETPLACE_TAB = "templates";

export const MARKETPLACE_TAB_IDS = ["templates"];

export const MARKETPLACE_VIEW_MODES = ["grid", "table"];

export const MARKETPLACE_TYPE_FILTERS = ["All", "Preventive", "Detective", "Mitigative"];

export const MARKETPLACE_STATUS_FILTERS = ["All", "Open", "In Progress", "Closed"];

export function isValidMarketplaceTab(tab) {
  if (!tab) return false;
  return MARKETPLACE_TAB_IDS.includes(tab);
}

/**
 * Build a shareable Marketplace module URL.
 * @param {string} tab
 * @param {{ q?: string, type?: string, status?: string, view?: string }} opts
 */
export function marketplacePath(tab = DEFAULT_MARKETPLACE_TAB, { q, type, status, view } = {}) {
  const safeTab = isValidMarketplaceTab(tab) ? tab : DEFAULT_MARKETPLACE_TAB;
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  if (type && type !== "All") params.set("type", type);
  if (status && status !== "All") params.set("status", status);
  if (view && view !== "grid") params.set("view", view);
  const qs = params.toString();
  return `/marketplace/${safeTab}${qs ? `?${qs}` : ""}`;
}

/** Parse pathname + search into Marketplace navigation state. */
export function parseMarketplaceLocation({ pathname, search }) {
  const parts = pathname.split("/").filter(Boolean);
  const tab = parts[1] || DEFAULT_MARKETPLACE_TAB;
  const params = new URLSearchParams(search || "");

  const type = params.get("type");
  const status = params.get("status");
  const view = params.get("view");

  return {
    tab: isValidMarketplaceTab(tab) ? tab : DEFAULT_MARKETPLACE_TAB,
    q: params.get("q") || "",
    type: MARKETPLACE_TYPE_FILTERS.includes(type) ? type : "All",
    status: MARKETPLACE_STATUS_FILTERS.includes(status) ? status : "All",
    view: MARKETPLACE_VIEW_MODES.includes(view) ? view : "grid",
  };
}
